import api from './index';

const postPlatformTourVideoWatched = () => {
  return api.post(`/v4/platform-tour-video/watched`);
};

export const PlatformTourService = {
  postPlatformTourVideoWatched,
};
